/** @format */

import { LoginContainer } from './style'
import { LogoWhiteIcon } from '@/shared/ui/icons'
import { Signin } from '@/features/auth'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@/entities/theme/model'
import { darkTheme } from '../../theme'
import { useEffect } from 'react'
import { setCookie } from '@/shared/lib/formatter'
const Login = () => {
  const { t } = useTranslation()
  const { theme, setTheme } = useTheme()
  useEffect(() => {
    if (typeof theme !== 'object') {
      setTheme(darkTheme)
      setCookie('theme', JSON.stringify(darkTheme))
      setCookie('themeName', 'dark')
    }
  }, [setTheme, theme])
  return (
    <LoginContainer>
      <LoginContainer.Box>
        <LoginContainer.BoxLeft>
          <Signin />
        </LoginContainer.BoxLeft>
        <LoginContainer.BoxRight />
      </LoginContainer.Box>
    </LoginContainer>
  )
}

export default Login
